export default __webpack_public_path__ + "static/media/warning-triangle-inverted.07405390.svg";